// https://discourse.threejs.org/t/solved-exporting-skinned-mesh-in-posed-position/5237/9

import * as THREE from 'three';

export const createPosedClone = (skinnedMesh, skeleton) => {
        
    let clone = skinnedMesh.clone();
    var boneMatrices = skeleton.boneMatrices;
    var geometry = skinnedMesh.geometry;
    
    var position = geometry.attributes.position;
    var skinIndex = geometry.attributes.skinIndex;
    var skinWeigth = geometry.attributes.skinWeight;
    
    var bindMatrix = skinnedMesh.bindMatrix;
    var bindMatrixInverse = skinnedMesh.bindMatrixInverse;
    
    var i, j, si, sw;


    var vertex = new THREE.Vector3();
    var temp = new THREE.Vector3();
    var skinned = new THREE.Vector3();
    var skinIndices = new THREE.Vector4();
    var skinWeights = new THREE.Vector4();
    var boneMatrix = new THREE.Matrix4();
    // non-indexed geometry

    for ( i = 0; i < position.count; i++ ) {
    
        vertex.fromBufferAttribute( position, i );
        skinIndices.fromBufferAttribute( skinIndex, i );
        skinWeights.fromBufferAttribute( skinWeigth, i );
        
        // the following code section is normally implemented in the vertex shader

        vertex.applyMatrix4( bindMatrix ); // transform to bind space
        skinned.set( 0, 0, 0 );

        for ( j = 0; j < 4; j ++ ) {
            si = skinIndices.getComponent( j );
            sw = skinWeights.getComponent( j );
            boneMatrix.fromArray( boneMatrices, si * 16 );

            // weighted vertex transformation

            temp.copy( vertex ).applyMatrix4( boneMatrix ).multiplyScalar( sw );
            skinned.add( temp );
        }

        skinned.applyMatrix4( bindMatrixInverse ); // back to local space

        clone.geometry.attributes.position.setXYZ(i, skinned.x, skinned.y, skinned.z);  
    }

    return clone;
}



// WEBPACK FOOTER //
// ./src/3dapps/js/exportSkinnedMesh.js